/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Crown-Silver': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M2.667 9.333l8 4.267L16 6.667l6.667 6.933 6.666-4.267-1.333 16H4l-1.333-16z" _fill="#CFCFCF"/><path pid="1" d="M13.93 22h4.96v-1.24h-1.61c-.34 0-.83.04-1.2.08 1.35-1.32 2.46-2.76 2.46-4.1 0-1.38-.93-2.28-2.33-2.28-1.01 0-1.67.4-2.35 1.12l.8.8c.37-.41.82-.76 1.36-.76.7 0 1.11.45 1.11 1.2 0 1.14-1.19 2.53-3.2 4.33V22z" _fill="#fff"/>'
  }
})
